import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class AdminDashboardSubscriberStatsDto {
  @Field(type => Int)
  monthlyRevenue!: number

  @Field(type => Int)
  payingCustomerCount!: number

  @Field(type => Int)
  totalUserCount!: number

  @Field(type => Int)
  reviewerCount!: number

  @Field(type => Int)
  authorCount!: number

  @Field(type => Int)
  growingCount!: number

  @Field(type => Int)
  proCount!: number

  @Field(type => Int)
  bestSellerCount!: number

  @Field(type => Int)
  publisherCount!: number

  @Field(type => Int)
  newReviewerCount!: number
}
